/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
} from '@angular/core';

import { HTTPStatusMatch } from 'object-types';
import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';
import { HTTPStatusMatchConfigItem }
    from 'ajs/modules/match/factories/http-status-match.config-item.factory';

import * as l10n from './http-status-match.component.l10n';
import './http-status-match.component.less';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description
 *     Match component for HTTPStatusMatch Message.
 * @author Abhinesh Gour
 */
@Component({
    selector: 'http-status-match',
    templateUrl: './http-status-match.component.html',
})
export class HttpStatusMatchComponent implements OnInit {
    /**
     * HTTPStatusMatch message item instance.
     */
    @Input()
    public editable: HTTPStatusMatchConfigItem;

    /**
     * Match label passed to the MatchWrapperComponent.
     */
    @Input()
    public label: string;

    /**
     * Index of the match within the MatchAdder component.
     */
    @Input()
    public matchIndex = 0;

    /**
     * objectType passed to the MatchWrapperComponent.
     */
    @Input()
    public objectType: string;

    /**
     * fieldName passed to the MatchWrapperComponent.
     */
    @Input()
    public fieldName: string;

    /**
     * EventEmitter for removing a match, passed to the MatchWrapperComponent.
     */
    @Output()
    public onRemoveMatch = new EventEmitter<void>();

    /**
     * Get keys from source bundles for template usage.
     */
    public readonly l10nKeys = l10nKeys;

    /**
     * Keys from global source bundles for template usage.
     */
    public readonly globalL10nKeys = globalL10nKeys;

    /**
     * Object Type to be used in template for tooltip.
     */
    public readonly httpStatusMatchObjectType = HTTPStatusMatch;

    /**
     * statusCodesAndRanges will hold codes and ranges flatten array of type string.
     */
    public statusCodesAndRanges: string[];

    constructor(private readonly l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngOnInit(): void {
        this.statusCodesAndRanges = this.editable.getRangesAndCodesAsList();
    }

    /**
     * Handler to set status codes and ranges.
     */
    public handleStatusCodesAndRangesChange(): void {
        this.editable.setStatusCodesAndRanges(this.statusCodesAndRanges);
    }

    /**
     * Called to remove this match. Passed to the MatchWrapperComponent.
     */
    public removeMatch(): void {
        this.onRemoveMatch.emit();
    }
}
